export default __webpack_public_path__ + "static/media/SENSIS_WHITE_PAGES.5086c0c4.png";